import { useQuery } from '@tanstack/react-query';
import { useAuthorBatch } from '@/hooks/useAuthorBatch';
import type { AuthorData } from '@/contexts/AuthorContext';

export function useAuthor(pubkey: string | undefined) {
  const { load } = useAuthorBatch();

  return useQuery<AuthorData>({
    queryKey: ['nostr', 'author', pubkey ?? ''],
    queryFn: () => load(pubkey!),
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000, // Keep cached data fresh for 5 minutes
  });
}
